var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',[_c('v-col',{attrs:{"cols":"3"}},[_c('menus')],1),_c('v-col',{attrs:{"cols":"9"}},[_c('div',{staticClass:"cabinet",staticStyle:{"text-align":"center"}},[_c('h1',[_vm._v("Админ панель")])])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }